import React from 'react';
import {
  Filter as FilterAdmin,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';

import { PeriodoInput } from '../../Components/InputsReactAdmin';
import { STATUS_ATIVO } from '../../utils';

const Filter = (props) => (
  <FilterAdmin {...props}>
    <ReferenceInput
      fullWidth
      label="Fornecedor"
      source="fornecedor_id"
      reference="fornecedores"
      sort={{ field: 'nome', order: 'ASC' }}
      filterToQuery={(searchText) => ({ nome: `${searchText}` })}
      filter={{ status: STATUS_ATIVO }}
    >
      <AutocompleteInput optionText="nome" />
    </ReferenceInput>
    <PeriodoInput
      source="periodo_agendamento"
      label="Próxima Data de Compra"
      defaultValue={{ start: new Date(), end: new Date() }}
    />
    <PeriodoInput
      source="periodo_confirmacao"
      label="Última Confirmação"
      defaultValue={{ start: new Date(), end: new Date() }}
    />
  </FilterAdmin>
);

export default Filter;
